import { createSelector } from 'reselect';

const selectAuthentication = (state) => state.authentication;

const selectOtpToken = createSelector(
	selectAuthentication,
	(authentication) => authentication?.otpToken
);

const selectUser = createSelector(
	selectAuthentication,
	(authentication) => authentication?.user
);

export const selectBusinessList = createSelector(
	selectAuthentication,
	(authentication) => authentication?.businessList
);

const selectBusinessId = createSelector(
	selectAuthentication,
	(authentication) => authentication?.user?.business?.id
);

const selectAuthenticated = createSelector(
	selectAuthentication,
	(authentication) => authentication?.isAuthenticated
);

const selectAppInitializing = createSelector(
	selectAuthentication,
	(authentication) => authentication?.isAppInitializing
);

const selectSessions = createSelector(
	selectAuthentication,
	(authentication) => authentication?.sessions
);

const authenticationSelectors = {
	selectAuthentication,
	selectBusinessList,
	selectOtpToken,
	selectUser,
	selectAuthenticated,
	selectAppInitializing,
	selectSessions,
	selectBusinessId,
};

export default authenticationSelectors;
